import {
  books,
  spider,
  faceoncake,
  gdsc1,
  gdsc2,
  gdsc3,
  clgfries,
  flag
} from '../../Assets/Gallery/index';

export const GalleryData = [
  {
    id: 1,
    imgSrc: spider
  },
  {
    id: 2,
    imgSrc: books
  },
  {
    id: 3,
    imgSrc: faceoncake
  },
  {
    id: 4,
    imgSrc: gdsc1
  },
  {
    id: 7,
    imgSrc: flag
  },
  {
    id: 5,
    imgSrc: clgfries
  },
  {
    id: 6,
    imgSrc: gdsc2
  },
  {
    id: 8,
    imgSrc: gdsc3
  }
];
